import { bus } from "@/main"
import C from "highlight.js/lib/languages/1c"
import { isNull } from "util"

// EVALUATION Store
const state = {
  STATUS: null,
  baseURL: process.env.VUE_APP_URL,
  API_ROUTE: "/screening-eval/",
  screeningPath: process.env.VUE_APP_SCREENING_PACKAGES,
  screeningID: "",
  storageID: "",
  isLoading: false,

  imagesArray: [],
  selections: [],
  screening: {},
  imgReset: {},

  mDxDiagnoses: [],
  dxOptionsList: [],
  dxCards: [],
  otherDxCards: [],
  allDxCards: {},
  eval: {
    // Info
    patientInfo: {
      internalID: "",
      externalID: "",
      firstName: "",
      lastName: "",
      fullName: "",
      email: "",
      phone: "",
      dob: "",
      chiefComplaint: "",
      issues: "",
      gender: "n/a",
      wearsCorrectiveLens: "",
      address: {
        addressLn1: "3930 US-1",
        addressLn2: "GlobeChek Building HQ",
        city: "Vero Beach",
        state: "FL",
        zip: "32960",
        country: "USA"
      },
      screenType: null,
      patientUserID: null,
      insurance: "",
      insuranceID: "",
      groupNumber: "",
      referralNumber: "",
      insuredPersonID: null,
      relationshipToInsured: ""
    },
    insurerInfo: {
      firstName: "",
      lastName: "",
      fullName: "",
      dob: "",
      gender: "n/a",
      address: {
        address: "3930 US-1",
        city: "Vero Beach",
        state: "FL",
        zip: "32960",
        country: "USA"
      }
    },
    screeningInfo: {
      globeId: "",
      globeName: "",
      globeLocation: "",
      technician: "",
      screeningDate: "",
      screeningStart: "",
      screeningEnd: "",
      screeningDuration: ""
    },

    screeningAssets: {
      History: "",
      OCT: "",
      ANTSEG: "",
      Vision: "",
      Pressure: "",
      External: "",
      Corneal: "",
      Pachymetry: "",
      Opacity: "",
      Fundus: "",
      Macula: "",
      Nerve: ""
    },
    visionInfo: {
      acuityDistanceOD: "n/a",
      acuityDistanceOS: "n/a",
      acuityNearOD: "n/a",
      acuityNearOS: "n/a",
      acuityWCorrectionD: "sc", //'without correction',
      acuityWCorrectionN: "sc", //'without correction',
      autoRefractionOD: "n/a",
      autoRefractionOS: "n/a",
      eyePressureOD: "n/a",
      eyePressureOS: "n/a",
      correctedIOP_OD: "n/a",
      correctedIOP_OS: "n/a",
      pachymeterCornealOD: "n/a",
      pachymeterCornealOS: "n/a",
      angleMeasurementOD: "n/a",
      angleMeasurementOS: "n/a",
      anteriorThicknessOD: "n/a",
      anteriorThicknessOS: "n/a",
      visionComments: "n/a", //contains pipe separated COLOR & DEPTH values
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    medicalInfo: {
      insurance: "",
      histSurgery: "",
      histCancer: "",
      histDiabetes: "",
      histOther: "",
      famOther: "",

      histCholesterol: "",
      histHeart: "",
      histLiver: "",
      histMigraines: "",
      histPressure: "",
      histStroke: "",

      famAlzheimers: "",
      famCancer: "",
      famCholesterol: "",
      famDiabetes: "",
      famGlaucoma: "",
      famHeart: "",
      famLiver: "",
      famMacDegen: "",
      famMigraines: "",
      famStroke: "",
      famPressure: "",

      histGlasses: {
        sphereOD: "",
        sphereOS: "",
        cylinderOD: "",
        cylinderOS: "",
        axisOD: "",
        axisOS: "",
        powerOD: "",
        powerOS: "",
        distanceOD: "",
        distanceOS: ""
      },
      histContacts: {
        sphereOD: "",
        sphereOS: "",
        cylinderOD: "",
        cylinderOS: "",
        axisOD: "",
        axisOS: "",
        powerOD: "",
        powerOS: "",
        distanceOD: "",
        distanceOS: "",
        baseCurveOD: "",
        baseCurveOS: "",
        diameterOD: "",
        diameterOS: "",
        colorOD: "",
        colorOS: ""
      }
    },
    rxInfo: {
      sphereOD: "",
      sphereOS: "",
      cylinderOD: "",
      cylinderOS: "",
      axisOD: "",
      axisOS: "",
      powerOD: "",
      powerOS: "",
      distanceOD: "",
      distanceOS: "",
      commentsOU: ""
    },
    notesInfo: {
      screeningNote: ""
    },
    // Photo
    externalPhoto: {
      imgExt: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    corneaPhoto: {
      imgCorOD: "", // 'export1_x_R.jpg',
      imgCorOS: "", // 'export1_x_L.jpg',
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    pachymetryPhoto: {
      imgPacOD: "", //'export2_x_R.jpg',
      imgPacOS: "", //'export2_x_L.jpg',
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    opacityPhoto: {
      imgOpaODOS: "", // 'export3_x.jpg',
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    fundusPhoto: {
      imgFunOD: "",
      imgFunOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    maculaPhoto: {
      imgMacOD: "",
      imgMacOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    nervePhoto: {
      imgNrvOD: "",
      imgNrvOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    },
    // Summary
    status: "",
    screeningStatus: "",
    sumPara: {
      diaOD_VIS: "",
      diaOS_VIS: "",
      diaOD_EXT: "",
      diaOS_EXT: "",
      diaOD_COR: "",
      diaOS_COR: "",
      diaOD_PAC: "",
      diaOS_PAC: "",
      diaOD_OPA: "",
      diaOS_OPA: "",
      diaOD_FUN: "",
      diaOS_FUN: "",
      diaOD_MAC: "",
      diaOS_MAC: "",
      diaOD_NRV: "",
      diaOS_NRV: "",
      diaVisionInfo: "",
      diaSumExternal: "",
      diaSumAnterior: "",
      diaSumPosterior: ""
    },
    outcomes: {
      findings: [],
      diagnoses: [],
      customDiagnoses: [],
      recommendations: [],
      customRecommendations: [],
      diagnoseTxt: "",
      diagnoseHtml: "",
      recommendText: "",
      recommendHtml: ""
    },
    icd10: [],
    cpt: [],
    final_Diagnoses: [],
    final_Recommendations: [],
    referrals: [],
    // This are the referrals previously selected and saved on our database
    savedReferrals: [],
    // This are the findings previously selected and saved on our database
    savedFindings: [],
    // This are the diagnoses previously selected and saved on our database
    savedDiagnoses: {}
  },
  createFinding: {
    isCreate: false,
    finding: {},
    sectionName: ""
  },
  lastUpdateByUser: null
}

const getters = {
  omniPhoto: (state) => (photo) => {
    if (!photo) return null
    switch (photo) {
      case "External":
        return state.eval.externalPhoto
      case "Cornea":
        return state.eval.corneaPhoto
      case "Pachymetry":
        return state.eval.pachymetryPhoto
      case "Opacity":
        return state.eval.opacityPhoto
      case "Fundus":
        return state.eval.fundusPhoto
      case "Macula":
        return state.eval.maculaPhoto
      case "Nerve":
        return state.eval.nervePhoto
    }
  },
  dxDiagnoses: (state) => {
    return state.mDxDiagnoses
  },
  omniSelected: (state) => {
    return state.selections
  },
  screening: (state) => {
    return state.screening
  },
  eval: (state) => {
    return state.eval
  },
  screeningID: (state) => {
    return state.screeningID //sessionStorage.getItem("screeningID")
  },
  imagesPath: (state) => {
    return (
      state.screeningPath +
      "/" +
      state.storageID + //sessionStorage.getItem("storageID") +
      "/IMAGES"
    )
  },
  patientInfo: (state) => {
    return state.eval.patientInfo
  },
  insurerInfo: (state) => {
    return state.eval.insurerInfo
  },
  screeningInfo: (state) => {
    return state.eval.screeningInfo
  },
  notesInfo: (state) => {
    return state.eval.notesInfo
  },
  screeningAssets: (state) => {
    return state.eval.screeningAssets
  },
  visionInfo: (state) => {
    return state.eval.visionInfo
  },
  medicalInfo: (state) => {
    return state.eval.medicalInfo
  },
  rxInfo: (state) => {
    return state.eval.rxInfo
  },

  externalPhoto: (state) => {
    return state.eval.externalPhoto
  },
  corneaPhoto: (state) => {
    return state.eval.corneaPhoto
  },
  pachymetryPhoto: (state) => {
    return state.eval.pachymetryPhoto
  },
  opacityPhoto: (state) => {
    return state.eval.opacityPhoto
  },
  fundusPhoto: (state) => {
    return state.eval.fundusPhoto
  },
  maculaPhoto: (state) => {
    return state.eval.maculaPhoto
  },
  nervePhoto: (state) => {
    return state.eval.nervePhoto
  },
  ddSelections: (state) => {
    return state.selections
  },
  ddFinalDiagnoses: (state) => {
    return state.eval.final_Diagnoses
  },
  ddFinalRecommendations: (state) => {
    return state.eval.final_Recommendations
  },
  eSummary: (state) => {
    return state.eval.eSummary
  },
  sumParagraph: (state) => {
    return state.eval.sumPara
  },
  referrals: (state) => {
    return state.eval.referrals
  },
  evalResults: (state) => {
    return state.eval.outcomes
  },
  icd10State: (state) => {
    return state.eval.icd10
  },
  cptState: (state) => {
    return state.eval.cpt
  },
  dxOptionsList: (state) => {
    return state.dxOptionsList
  },
  dxCards: (state) => {
    return state.dxCards
  },
  otherDxCards: (state) => {
    return state.otherDxCards
  },
  getCardsByModality: (state) => (modality) => {
    const emptyGroup = { OU: [], OS: [], OD: [] }
    return state.dxCards[modality] ? state.dxCards[modality] : emptyGroup
  },
  getAllCardsByModality: (state) => (modality) => {
    const emptyGroup = { OU: [], OS: [], OD: [] }
    return state.allDxCards[modality] ? state.allDxCards[modality] : emptyGroup
  },
  getOtherCardsByModality: (state) => (modality) => {
    const emptyGroup = { OU: [], OS: [], OD: [] }
    return state.otherDxCards[modality] ? state.otherDxCards[modality] : emptyGroup
  },
  createFinding: (state) => {
    return state.createFinding
  },
  getSavedReferrals: (state) => {
    return state.eval.savedReferrals
  },
  getSavedFindings: (state) => {
    return state.eval.savedFindings
  },
  getSavedDiagnoses: (state) => {
    return state.eval.savedDiagnoses
  },
  screeningStatus(state) {
    return state.eval.screeningStatus
  }
}

// Called from Action to change State
const mutations = {
  getScreening(state, screening) {
    state.screening = screening
  },
  updateCurrentEval(state, screening) {
    //console.log('Mut:updateCurrentEval')
    state.screening = screening
    commit("getPatientInfo")
    commit("getInsurerInfo")
    commit("getScreeningInfo")
    commit("getNotesInfo")
    commit("getScreeningAssets")
    commit("getVisionInfo")
    commit("getMedicalInfo")
    commit("getRxInfo")
    commit("getExternalPhoto")
    commit("getCorneaPhoto")
    commit("getPachymetryPhoto")
    commit("getOpacityPhoto")
    commit("getFundusPhoto")
    commit("getMaculaPhoto")
    commit("getNervePhoto")
    commit("getReferrals")
    commit("getFindings")
    commit("getDiagnoses")
    commit("getScreeningStatus")
  },
  // HELPER METHODS
  getPatientInfo(state) {
    try {
      //console.log('Mut:getPatientInfo')
      // Member
      state.eval.patientInfo.internalID = state.screening.mbrInternalID
      state.eval.patientInfo.externalID = state.screening.mbrExternalID
      state.eval.patientInfo.firstName = state.screening.mbrFirstName
      state.eval.patientInfo.lastName = state.screening.mbrLastName
      state.eval.patientInfo.fullName = state.screening.mbrFullName
      state.eval.patientInfo.email = state.screening.mbrEmail
      state.eval.patientInfo.screenType = state.screening.screenType
      state.eval.patientInfo.patientUserID = state.screening.patientUserID

      state.eval.patientInfo.phone = state.screening.mbrCellPhone
      state.eval.lastUpdateByUser = state.screening.lastUpdateByUser

      state.screening.mbrCellPhone === "" ? " " : state.screening.mbrCellPhone
      state.eval.patientInfo.dob = state.screening.mbrDOB
      state.eval.patientInfo.chiefComplaint = state.screening.mbrChiefComplaint
      state.eval.patientInfo.issues = state.screening.mbrIssues
      state.eval.patientInfo.gender = state.screening.mbrGender === "" ? "n/a" : state.screening.mbrGender
      state.eval.patientInfo.wearsCorrectiveLens = state.screening.mbrCorrectiveLens
      state.eval.patientInfo.insurance = state.screening.Insurance
      state.eval.patientInfo.insuranceID = state.screening.InsuranceID
      state.eval.patientInfo.groupNumber = state.screening.GroupNumber
      state.eval.patientInfo.referralNumber = state.screening.ReferralNumber
      state.eval.patientInfo.insuredPersonID = state.screening.mbrInsuredPersonID
      state.eval.patientInfo.relationshipToInsured = state.screening.mbrRelationshipToInsured
      // Address
      state.eval.patientInfo.address.addressLn1 =
        state.screening.mbrAddress1 === "" || isNull(state.screening.mbrAddress1) ? "\xA0" : state.screening.mbrAddress1
      state.eval.patientInfo.address.addressLn2 =
        state.screening.mbrAddress2 === "" || isNull(state.screening.mbrAddress2) ? "\xA0" : state.screening.mbrAddress2
      state.eval.patientInfo.address.city =
        state.screening.mbrCity === "" || isNull(state.screening.mbrCity) ? "\xA0" : state.screening.mbrCity
      state.eval.patientInfo.address.state =
        state.screening.mbrState === "" || isNull(state.screening.mbrState) ? "\xA0" : state.screening.mbrState
      state.eval.patientInfo.address.zip =
        state.screening.mbrZip === "" || isNull(state.screening.mbrZip) ? "\xA0" : state.screening.mbrZip
      state.eval.patientInfo.address.country =
        state.screening.mbrCountry === "" || isNull(state.screening.mbrCountry) ? "\xA0" : state.screening.mbrCountry
    } catch (error) {
      console.log("PatientInfo")
      console.log(error)
    }
  },
  getInsurerInfo(state) {
    try {
      //console.log('Mut:getPatientInfo')
      // Insurer
      state.eval.insurerInfo.firstName = state.screening.insFirstName
      state.eval.insurerInfo.lastName = state.screening.insLastName
      state.eval.insurerInfo.fullName = state.screening.insFullName

      state.eval.insurerInfo.dob = state.screening.insDOB
      state.eval.insurerInfo.gender = state.screening.insGender === "" ? "n/a" : state.screening.insGender
      // Address
      state.eval.insurerInfo.address.address =
        state.screening.insAddress === "" || isNull(state.screening.insAddress) ? "\xA0" : state.screening.insAddress
      state.eval.insurerInfo.address.city =
        state.screening.insCity === "" || isNull(state.screening.insCity) ? "\xA0" : state.screening.insCity
      state.eval.insurerInfo.address.state =
        state.screening.insState === "" || isNull(state.screening.insState) ? "\xA0" : state.screening.insState
      state.eval.insurerInfo.address.zip =
        state.screening.insZip === "" || isNull(state.screening.insZip) ? "\xA0" : state.screening.insZip
      state.eval.insurerInfo.address.country =
        state.screening.insCountry === "" || isNull(state.screening.insCountry) ? "\xA0" : state.screening.insCountry
    } catch (error) {
      console.log("insurerInfo")
      console.log(error)
    }
  },
  getScreeningInfo(state) {
    try {
      //console.log('Mut:getScreeningInfo')
      state.eval.screeningInfo.globeId =
        state.screening.globeID === "" || isNull(state.screening.globeID) ? "\xA0" : state.screening.globeID

      state.eval.screeningInfo.globeName =
        state.screening.globeName === "" || isNull(state.screening.globeName) ? "\xA0" : state.screening.globeName

      state.eval.screeningInfo.globeLocation =
        state.screening.globeLocation === "" || isNull(state.screening.globeLocation)
          ? "\xA0"
          : state.screening.globeLocation

      state.eval.screeningInfo.technician =
        state.screening.globeTechnician === "" || isNull(state.screening.globeTechnician)
          ? "\xA0"
          : state.screening.globeTechnician

      state.eval.screeningInfo.screeningDate =
        state.screening.screenStart === "" || isNull(state.screening.screenStart) ? "\xA0" : state.screening.screenStart

      state.eval.screeningInfo.screeningStart =
        state.screening.screenStart === "" || isNull(state.screening.screenStart) ? "\xA0" : state.screening.screenStart

      state.eval.screeningInfo.screeningEnd =
        state.screening.screenEnd === "" || isNull(state.screening.screenEnd) ? "\xA0" : state.screening.screenEnd

      state.eval.screeningInfo.screeningDuration =
        state.screening.screenDuration === "" || isNull(state.screening.screenDuration)
          ? "\xA0"
          : state.screening.screenDuration
    } catch (error) {
      console.log("ScreeningInfo")
      console.log(error)
    }
  },
  getNotesInfo(state) {
    try {
      state.eval.notesInfo.screeningNote = state.screening.screeningNotes
    } catch (error) {
      console.log("ScreeningNotes")
      console.log(error)
    }
  },

  getScreeningAssets(state) {
    try {
      //console.log('Mut:getScreeningAssets')
      // XML Assets
      state.eval.screeningAssets.History =
        state.screening.histSurgery != null ||
        state.screening.histCancer != null ||
        state.screening.histDiabetes != null
          ? true
          : false

      state.eval.screeningAssets.OCT =
        state.screening.imgFundusOD != null || state.screening.imgMaculaOS != null || state.screening.imgNerveOD != null
          ? true
          : false

      state.eval.screeningAssets.ANTSEG = state.screening.AnteriorSegment != null ? true : false

      state.eval.screeningAssets.Vision =
        state.screening.visionAcuityDistanceOD != null ||
        state.screening.visionAcuityDistanceOS != null ||
        state.screening.visionAcuityNearOD != null ||
        state.screening.visionAcuityNearOD != null
          ? true
          : false

      state.eval.screeningAssets.Pressure =
        state.screening.visionEyePressureOD != null || state.screening.visionEyePressureOS != null ? true : false

      state.eval.screeningAssets.visionComments = state.screening.visionComments != null ? true : false

      // IMG Assets
      state.eval.screeningAssets.External = state.eval.externalPhoto.imgExt != null ? true : false
      state.eval.screeningAssets.Fundus = state.eval.fundusPhoto.imgFunOD != null
      state.eval.fundusPhoto.imgFunOS != null ? true : false
      state.eval.screeningAssets.Macula =
        state.eval.maculaPhoto.imgMacOD != null || state.eval.maculaPhoto.imgMacOS != null ? true : false
      state.eval.screeningAssets.Nerve =
        state.eval.nervePhoto.imgNrvOD != null || state.eval.nervePhoto.imgNrvOS != null ? true : false
      state.eval.screeningAssets.Corneal =
        state.eval.corneaPhoto.imgCorOD != null || state.eval.corneaPhoto.imgCorOS != null ? true : false
      state.eval.screeningAssets.Pachymetry =
        state.eval.pachymetryPhoto.imgPacOD != null || state.eval.pachymetryPhoto.imgPacOS != null ? true : false
      state.eval.screeningAssets.Opacity = state.eval.opacityPhoto.imgOpaODOS != null ? true : false
    } catch (error) {
      console.log("ERROR ScreeningAssets")
      console.log(error)
    }
  },
  getVisionInfo(state) {
    try {
      //console.log('Mut:getVisionInfo')
      state.eval.visionInfo.acuityDistanceOD =
        (state.screening.visionAcuityDistanceOD == null) | (state.screening.visionAcuityDistanceOD == "")
          ? "n/a"
          : state.screening.visionAcuityDistanceOD

      state.eval.visionInfo.acuityDistanceOS =
        (state.screening.visionAcuityDistanceOS == null) | (state.screening.visionAcuityDistanceOS == "")
          ? "n/a"
          : state.screening.visionAcuityDistanceOS

      state.eval.visionInfo.acuityNearOD =
        (state.screening.visionAcuityNearOD == null) | (state.screening.visionAcuityNearOD == "")
          ? "n/a"
          : state.screening.visionAcuityNearOD

      state.eval.visionInfo.acuityNearOS =
        (state.screening.visionAcuityNearOS == null) | (state.screening.visionAcuityNearOS == "")
          ? "n/a"
          : state.screening.visionAcuityNearOS

      //state.eval.visionInfo.acuityWCorrection = (state.screening.visionAcuityWithCorrection == null | state.screening.visionAcuityWithCorrection == '') ? 'without correction' : state.screening.visionAcuityWithCorrection
      state.eval.visionInfo.acuityWCorrectionD =
        (state.screening.visionAcuityWithCorrectionD == null) | (state.screening.visionAcuityWithCorrectionD == "")
          ? "sc"
          : "cc"

      state.eval.visionInfo.acuityWCorrectionN =
        (state.screening.visionAcuityWithCorrectionN == null) | (state.screening.visionAcuityWithCorrectionN == "")
          ? "sc"
          : "cc"

      state.eval.visionInfo.visionComments =
        (state.screening.visionComments == null) | (state.screening.visionComments == "")
          ? " n/a | n/a | n/a "
          : state.screening.visionComments

      state.eval.visionInfo.autoRefractionOD = state.screening.visionAutoRefractionOD

      state.eval.visionInfo.autoRefractionOS = state.screening.visionAutoRefractionOS

      state.eval.visionInfo.eyePressureOD =
        (state.screening.visionEyePressureOD == null) | (state.screening.visionEyePressureOD == "")
          ? "n/a"
          : Math.round(state.screening.visionEyePressureOD)

      state.eval.visionInfo.eyePressureOS =
        (state.screening.visionEyePressureOS == null) | (state.screening.visionEyePressureOS == "")
          ? "n/a"
          : Math.round(state.screening.visionEyePressureOS)

      state.eval.visionInfo.correctedIOP_OD =
        (state.screening.visionCorrectedIOPOD == null) | (state.screening.visionCorrectedIOPOD == "")
          ? "n/a"
          : Math.round(state.screening.visionCorrectedIOPOD)

      state.eval.visionInfo.correctedIOP_OS =
        (state.screening.visionCorrectedIOPOS == null) | (state.screening.visionCorrectedIOPOS == "")
          ? "n/a"
          : Math.round(state.screening.visionCorrectedIOPOS)

      state.eval.visionInfo.angleMeasurementOD =
        (state.screening.visionAngleOD == null) | (state.screening.visionAngleOD == "")
          ? "n/a"
          : state.screening.visionAngleOD

      state.eval.visionInfo.angleMeasurementOS =
        (state.screening.visionAngleOS == null) | (state.screening.visionAngleOS == "")
          ? "n/a"
          : state.screening.visionAngleOS

      state.eval.visionInfo.anteriorThicknessOD =
        (state.screening.visionThicknessOD == null) | (state.screening.visionThicknessOD == "")
          ? "n/a"
          : state.screening.visionThicknessOD

      state.eval.visionInfo.anteriorThicknessOS =
        (state.screening.visionThicknessOS == null) | (state.screening.visionThicknessOS == "")
          ? "n/a"
          : state.screening.visionThicknessOS
    } catch (error) {
      console.log("getScreeningAssets")
      console.log(error)
    }
  },
  getMedicalInfo(state) {
    try {
      state.eval.medicalInfo.insurance = state.screening.Insurance
      state.eval.medicalInfo.histSurgery = state.screening.histSurgery
      state.eval.medicalInfo.histCancer = state.screening.histCancer
      state.eval.medicalInfo.histDiabetes = state.screening.histDiabetes
      state.eval.medicalInfo.histOther = state.screening.histOther
      state.eval.medicalInfo.famOther = state.screening.famOther

      state.eval.medicalInfo.histCholesterol = state.screening.histCholesterol
      state.eval.medicalInfo.histHeart = state.screening.histHeart
      state.eval.medicalInfo.histLiver = state.screening.histLiver
      state.eval.medicalInfo.histMigraines = state.screening.histMigraines
      state.eval.medicalInfo.histPressure = state.screening.histPressure
      state.eval.medicalInfo.histStroke = state.screening.histStroke

      state.eval.medicalInfo.famAlzheimers = state.screening.famAlzheimers
      state.eval.medicalInfo.famCancer = state.screening.famCancer
      state.eval.medicalInfo.famCholesterol = state.screening.famCholesterol
      state.eval.medicalInfo.famDiabetes = state.screening.famDiabetes
      state.eval.medicalInfo.famGlaucoma = state.screening.famGlaucoma
      state.eval.medicalInfo.famHeart = state.screening.famHeart
      state.eval.medicalInfo.famLiver = state.screening.famLiver
      state.eval.medicalInfo.famMacDegen = state.screening.famMacDegen
      state.eval.medicalInfo.famMigraines = state.screening.famMigraines
      state.eval.medicalInfo.famStroke = state.screening.famStroke
      state.eval.medicalInfo.famPressure = state.screening.famPressure
    } catch (error) {
      console.log("MedicalInfo")
      console.log(error)
    }
  },
  getRxInfo(state) {
    try {
      state.eval.rxInfo.sphereOD = null
      state.eval.rxInfo.sphereOS = null
      state.eval.rxInfo.cylinderOD = null
      state.eval.rxInfo.cylinderOS = null
      state.eval.rxInfo.axisOD = null
      state.eval.rxInfo.axisOS = null
      state.eval.rxInfo.powerOD = null
      state.eval.rxInfo.powerOS = null
      state.eval.rxInfo.distanceOD = null
      state.eval.rxInfo.distanceOS = null
      state.eval.rxInfo.commentsOU = null
    } catch (error) {
      console.log("ERROR RxInfo")
      console.log(error)
    }
  },

  getExternalPhoto(state) {
    try {
      //var imgOU = state.imagesArray.find(({ id }) => id === "EXT");
      //state.eval.externalPhoto.imgExt = imgOU ? imgOU.file : null;

      state.eval.externalPhoto.imgExt = state.screening.imgExt ? state.screening.imgExt : null

      //console.log("**imgExt: " + state.eval.externalPhoto.imgExt);
    } catch (error) {
      console.log("ERROR getExternalPhoto")
      console.log(error)
    }
  },
  getCorneaPhoto(state) {
    try {
      state.eval.corneaPhoto.imgCorOD = state.screening.corOD ? state.screening.corOD : null
      state.eval.corneaPhoto.imgCorOS = state.screening.corOS ? state.screening.corOS : null
      //console.log("**imgCor OD|OS: " + state.eval.corneaPhoto.imgCorOD + "|" + state.eval.corneaPhoto.imgCorOS );
    } catch (error) {
      console.log("ERROR getCorneaPhoto")
      console.log(error)
    }
  },
  getPachymetryPhoto(state) {
    try {
      state.eval.pachymetryPhoto.imgPacOD = state.screening.pacOD ? state.screening.pacOD : null
      state.eval.pachymetryPhoto.imgPacOS = state.screening.pacOS ? state.screening.pacOS : null
      //console.log("**imgPac OD|OS: " + state.eval.pachymetryPhoto.imgPacOD + "|" + state.eval.pachymetryPhoto.imgPacOS );
    } catch (error) {
      console.log("ERROR getPachymetryPhoto")
      console.log(error)
    }
  },
  getOpacityPhoto(state) {
    try {
      state.eval.opacityPhoto.imgOpaODOS = state.screening.opaOD ? state.screening.opaOD : null
      //console.log("**imgOpa OU: " + state.eval.opacityPhoto.imgOpaODOS );
    } catch (error) {
      console.log("ERROR getOpacityPhoto")
      console.log(error)
    }
  },
  getFundusPhoto(state) {
    try {
      state.eval.fundusPhoto.imgFunOD = state.screening.funOD ? state.screening.funOD : null
      state.eval.fundusPhoto.imgFunOS = state.screening.funOS ? state.screening.funOS : null
      //console.log("**imgFun OD|OS: " + state.eval.fundusPhoto.imgFunOD + "|" + state.eval.fundusPhoto.imgFunOS );
    } catch (error) {
      console.log("ERROR getFundusPhoto")
      console.log(error)
    }
  },
  getMaculaPhoto(state) {
    try {
      state.eval.maculaPhoto.imgMacOD = state.screening.macOD ? state.screening.macOD : null
      state.eval.maculaPhoto.imgMacOS = state.screening.macOS ? state.screening.macOS : null
      //console.log("**imgMac OD|OS: " + state.eval.maculaPhoto.imgMacOD + "|" + state.eval.maculaPhoto.imgMacOD );
    } catch (error) {
      console.log("ERROR getMaculaPhoto")
      console.log(error)
    }
  },
  getNervePhoto(state) {
    try {
      state.eval.nervePhoto.imgNrvOD = state.screening.nrvOD ? state.screening.nrvOD : null
      state.eval.nervePhoto.imgNrvOS = state.screening.nrvOS ? state.screening.nrvOS : null
      //console.log("**imgNrv OD|OS: " + state.eval.nervePhoto.imgNrvOD + "|" + state.eval.nervePhoto.imgNrvOS );
    } catch (error) {
      console.log("ERROR getMaculaPhoto")
      console.log(error)
    }
  },
  getReferrals(state) {
    try {
      //console.log('Mut:getReferrals')
      state.eval.savedReferrals = state.screening.referralDoctors
    } catch (error) {
      console.log("ERROR getReferrals")
      console.log(error)
    }
  },
  getGlassesHistory(state) {
    try {
      state.eval.medicalInfo.histGlasses = state.screening.glassesHistory
    } catch (error) {
      console.log("ERROR getGlassesHistory")
      console.log(error)
    }
  },
  getContactsHistory(state) {
    try {
      state.eval.medicalInfo.histContacts = state.screening.contactsHistory
    } catch (error) {
      console.log("ERROR getContactsHistory")
      console.log(error)
    }
  },
  getFindings(state) {
    try {
      state.eval.savedFindings = state.screening.findings
    } catch (error) {
      console.log("ERROR getFindings")
      console.log(error)
    }
  },
  getDiagnoses(state) {
    try {
      //console.log('Mut:getDiagnoses')
      state.eval.savedDiagnoses = state.screening.diagnosis
    } catch (error) {
      console.log("ERROR getDiagnoses")
      console.log(error)
    }
  },
  getScreeningStatus(state) {
    try {
      //console.log('Mut:getScreeningStatus')
      state.eval.screeningStatus = state.screening.status
    } catch (error) {
      console.log("ERROR getScreeningStatus")
      console.log(error)
    }
  },
  updateFCount() {
    state.selections = []
    const technical_findings = ["normal", "essentially normal", "poor image quality", "unreliable test", "not tested"]

    // Technical-Findings Filter
    const filterTechnical = (item) => {
      !technical_findings.includes(item.toLowerCase())
    }

    const photoKeys = [
      "externalPhoto",
      "corneaPhoto",
      "pachymetryPhoto",
      "opacityPhoto",
      "fundusPhoto",
      "maculaPhoto",
      "nervePhoto"
    ]

    photoKeys.forEach((key) => {
      const fIDs = state.eval[key].fIDs
      state.selections.push(...fIDs.filter(filterTechnical))
    })
  },
  // updateFCount() {
  //   state.selections = []
  //   const technical_findings = [801, 802, 23, 24, 1001]

  //   // Technical-Findings Filter
  //   const filterTechnical = (id) => !technical_findings.includes(parseInt(id.split(".")[0]))

  //   state.selections.push(...state.eval.externalPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.corneaPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.pachymetryPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.opacityPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.fundusPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.maculaPhoto.fIDs.filter(filterTechnical))
  //   state.selections.push(...state.eval.nervePhoto.fIDs.filter(filterTechnical))
  // },

  updateSummary() {
    //console.log('Mut:updateSummary')
    //CLEAR VALUES

    state.eval.sumPara.diaOD_VIS = ""
    state.eval.sumPara.diaOS_VIS = ""
    state.eval.sumPara.diaOU_VIS = ""
    //
    state.eval.sumPara.diaOD_EXT = ""
    state.eval.sumPara.diaOS_EXT = ""
    state.eval.sumPara.diaOU_EXT = ""
    //
    state.eval.sumPara.diaOD_COR = ""
    state.eval.sumPara.diaOS_COR = ""
    state.eval.sumPara.diaOU_COR = ""
    //
    state.eval.sumPara.diaOD_PAC = ""
    state.eval.sumPara.diaOS_PAC = ""
    state.eval.sumPara.diaOU_PAC = ""
    //
    state.eval.sumPara.diaOD_OPA = ""
    state.eval.sumPara.diaOS_OPA = ""
    state.eval.sumPara.diaOU_OPA = ""
    //
    state.eval.sumPara.diaOD_FUN = ""
    state.eval.sumPara.diaOS_FUN = ""
    state.eval.sumPara.diaOU_FUN = ""
    //
    state.eval.sumPara.diaOD_MAC = ""
    state.eval.sumPara.diaOS_MAC = ""
    state.eval.sumPara.diaOU_MAC = ""
    //
    state.eval.sumPara.diaOD_NRV = ""
    state.eval.sumPara.diaOS_NRV = ""
    state.eval.sumPara.diaOU_NRV = ""
    //

    state.eval.sumPara.diaVisionInfo = ""
    state.eval.sumPara.diaSumExternal = ""
    state.eval.sumPara.diaSumAnterior = ""
    state.eval.sumPara.diaSumPosterior = ""

    const DIAG_POST_OD = " of the right eye. "
    const DIAG_POST_OS = " of the left eye. "
    const DIAG_MEASURES = []
    var DIAG_MEASURES_TEXT = ""

    // OHTN?
    const isElevatedOD = parseInt(state.eval.visionInfo.eyePressureOD) > 21 ||
                       parseInt(state.eval.visionInfo.correctedIOP_OD) > 21;
    
    const isElevatedOS = parseInt(state.eval.visionInfo.eyePressureOS) > 21 ||
                       parseInt(state.eval.visionInfo.correctedIOP_OS) > 21;
    
    // IOP Checks
    if (isElevatedOD && isElevatedOS) {
      const diagnosis = "Ocular Hypertension, bilateral (H40.053)";
      state.eval.final_Diagnoses.push(diagnosis);
      DIAG_MEASURES.push(diagnosis);
    
    } else if (isElevatedOD) {
      const diagnosis = "Ocular Hypertension of Right Eye (H40.051)";
      state.eval.final_Diagnoses.push(diagnosis);
      DIAG_MEASURES.push(diagnosis);
    
    } else if (isElevatedOS) {
      const diagnosis = "Ocular Hypertension of Left Eye (H40.052)";
      state.eval.final_Diagnoses.push(diagnosis);
      DIAG_MEASURES.push(diagnosis);
    }

    // PACHYMETRY
    var upperLimit_Corneal = parseInt(20)
    var lowerLimit_Corneal = parseInt(10)
    if (
      parseInt(state.eval.visionInfo.pachymeterCornealOD) > upperLimit_Corneal ||
      parseInt(state.eval.visionInfo.pachymeterCornealOS) > upperLimit_Corneal
    ) {
      state.eval.final_Diagnoses.push("Corneal Edema")
      DIAG_MEASURES.push("Corneal Edema")
    }

    if (
      parseInt(state.eval.visionInfo.pachymeterCornealOD) < lowerLimit_Corneal ||
      parseInt(state.eval.visionInfo.pachymeterCornealOS) < lowerLimit_Corneal
    ) {
      state.eval.final_Diagnoses.push("Corneal Thinning")
      DIAG_MEASURES.push("Corneal Thinning")
    }

    // ANGLE MEASUREMENT
    var lowerLimit_Angle = parseInt(20)
    if (
      parseInt(state.eval.visionInfo.angleMeasurementOD) < lowerLimit_Angle ||
      parseInt(state.eval.visionInfo.angleMeasurementOS) < lowerLimit_Angle
    ) {
      state.eval.final_Diagnoses.push("Narrow Angle")
      DIAG_MEASURES.push("Narrow Angle")
    }

    //UPDATE VALUES with SELECTED

    // Vision Info
    if (state.eval.visionInfo.findingsOD.length) {
      state.eval.sumPara.diaOD_VIS = state.eval.visionInfo.findingsOD.join(", ") + DIAG_POST_OD // DIAG_POST_OD = "of the RIGHT eye. ";
    }
    if (state.eval.visionInfo.findingsOS.length) {
      state.eval.sumPara.diaOS_VIS = state.eval.visionInfo.findingsOS.join(", ") + DIAG_POST_OS // DIAG_POST_OS = "of the LEFT eye. ";
    }
    if (state.eval.sumPara.diaOD_VIS.length || state.eval.sumPara.diaOS_VIS.length) {
      state.eval.sumPara.diaVisionInfo =
        "Vision Information showing " + state.eval.sumPara.diaOD_VIS + state.eval.sumPara.diaOS_VIS
    }

    // EXTERIOR
    if (state.eval.externalPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_EXT = state.eval.externalPhoto.findingsOD.join(", ") + DIAG_POST_OD
    }
    if (state.eval.externalPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_EXT = state.eval.externalPhoto.findingsOS.join(", ") + DIAG_POST_OS
    }

    if (state.eval.sumPara.diaOD_EXT.length || state.eval.sumPara.diaOS_EXT.length) {
      state.eval.sumPara.diaSumExternal =
        "External examination showing " + state.eval.sumPara.diaOD_EXT + state.eval.sumPara.diaOS_EXT
    }

    //ANTERIOR
    if (state.eval.corneaPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_COR = state.eval.corneaPhoto.findingsOD.join(", ")
    }
    if (state.eval.corneaPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_COR = state.eval.corneaPhoto.findingsOS.join(", ")
    }
    if (state.eval.pachymetryPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_PAC = state.eval.pachymetryPhoto.findingsOD.join(", ")
    }
    if (state.eval.pachymetryPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_PAC = state.eval.pachymetryPhoto.findingsOS.join(", ")
    }
    if (state.eval.opacityPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_OPA = state.eval.opacityPhoto.findingsOD.join(", ")
    }
    if (state.eval.opacityPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_OPA = state.eval.opacityPhoto.findingsOS.join(", ")
    }
    if (DIAG_MEASURES.length) {
      DIAG_MEASURES_TEXT = DIAG_MEASURES.join(", ")
    }

    if (
      state.eval.sumPara.diaOD_COR.length ||
      state.eval.sumPara.diaOS_COR.length ||
      state.eval.sumPara.diaOD_PAC.length ||
      state.eval.sumPara.diaOS_PAC.length ||
      state.eval.sumPara.diaOD_OPA.length ||
      state.eval.sumPara.diaOS_OPA.length
    ) {
      state.eval.sumPara.diaSumAnterior = "Anterior Segment OCT examination showing "

      if (
        state.eval.sumPara.diaOD_COR.length ||
        state.eval.sumPara.diaOD_PAC.length ||
        state.eval.sumPara.diaOD_OPA.length
      ) {
        if (state.eval.sumPara.diaOD_COR.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOD_COR
        }
        if (state.eval.sumPara.diaOD_PAC.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOD_PAC
        }
        if (state.eval.sumPara.diaOD_OPA.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOD_OPA
        }

        state.eval.sumPara.diaSumAnterior += DIAG_POST_OD
      }

      if (
        state.eval.sumPara.diaOS_COR.length ||
        state.eval.sumPara.diaOS_PAC.length ||
        state.eval.sumPara.diaOS_OPA.length
      ) {
        if (state.eval.sumPara.diaOS_COR.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOS_COR
        }
        if (state.eval.sumPara.diaOS_PAC.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOS_PAC
        }
        if (state.eval.sumPara.diaOS_OPA.length) {
          state.eval.sumPara.diaSumAnterior += state.eval.sumPara.diaOS_OPA
        }

        state.eval.sumPara.diaSumAnterior += DIAG_POST_OS
      }
      //+ DIAG_MEASURES_TEXT
    }

    //POSTERIOR
    if (state.eval.fundusPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_FUN = state.eval.fundusPhoto.findingsOD.join(", ")
    }
    if (state.eval.fundusPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_FUN = state.eval.fundusPhoto.findingsOS.join(", ")
    }
    if (state.eval.maculaPhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_MAC = state.eval.maculaPhoto.findingsOD.join(", ")
    }
    if (state.eval.maculaPhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_MAC = state.eval.maculaPhoto.findingsOS.join(", ")
    }
    if (state.eval.nervePhoto.findingsOD.length) {
      state.eval.sumPara.diaOD_NRV = state.eval.nervePhoto.findingsOD.join(", ")
    }
    if (state.eval.nervePhoto.findingsOS.length) {
      state.eval.sumPara.diaOS_NRV = state.eval.nervePhoto.findingsOS.join(", ")
    }

    if (
      state.eval.sumPara.diaOD_FUN.length ||
      state.eval.sumPara.diaOS_FUN.length ||
      state.eval.sumPara.diaOD_MAC.length ||
      state.eval.sumPara.diaOS_MAC.length ||
      state.eval.sumPara.diaOD_NRV.length ||
      state.eval.sumPara.diaOS_NRV.length
    ) {
      state.eval.sumPara.diaSumPosterior = "Posterior Segment examination showing "

      if (
        state.eval.sumPara.diaOD_FUN.length ||
        state.eval.sumPara.diaOD_MAC.length ||
        state.eval.sumPara.diaOD_NRV.length
      ) {
        if (state.eval.sumPara.diaOD_FUN.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOD_FUN
        }
        if (state.eval.sumPara.diaOD_MAC.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOD_MAC
        }
        if (state.eval.sumPara.diaOD_NRV.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOD_NRV
        }

        state.eval.sumPara.diaSumPosterior += DIAG_POST_OD
      }

      if (
        state.eval.sumPara.diaOS_FUN.length ||
        state.eval.sumPara.diaOS_MAC.length ||
        state.eval.sumPara.diaOS_NRV.length
      ) {
        if (state.eval.sumPara.diaOS_FUN.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOS_FUN
        }
        if (state.eval.sumPara.diaOS_MAC.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOS_MAC
        }
        if (state.eval.sumPara.diaOS_NRV.length) {
          state.eval.sumPara.diaSumPosterior += state.eval.sumPara.diaOS_NRV
        }

        state.eval.sumPara.diaSumPosterior += DIAG_POST_OS
      }
    }
  },

  updateDiagnoses() {
    // DIGNOSES RULES ENGINE //
    var _NORMAL_FINDINGS = ""
    var combiDiagsOD = new Set()
    var combiDiagsOS = new Set()
    var combiDiagsOU = new Set()
    var interim_DiagsOD = []
    var interim_DiagsOS = []
    var interim_DiagsOU = []

    // OD
    const modalities = [
      'visionInfo',
      'externalPhoto',
      'corneaPhoto',
      'pachymetryPhoto',
      'opacityPhoto',
      'fundusPhoto',
      'maculaPhoto',
      'nervePhoto'
    ];

    const processEye = (eye) => {
      const targetSet = eye === 'OD' ? combiDiagsOD :
        eye === 'OS' ? combiDiagsOS : combiDiagsOU;

      modalities.forEach(modality => {
        if (eye === 'OU' && modality === 'visionInfo') return;

        const diagnoses = state.eval[modality][`diagnoses${eye}`];
        if (Array.isArray(diagnoses)) {
          diagnoses.forEach(e => {
            if (e != null) targetSet.add(e);
          });
        }
      });
    };

    processEye('OD');
    processEye('OS');
    processEye('OU');

    if (
      combiDiagsOD.size == 0 &&
      combiDiagsOS.size == 0 &&
      combiDiagsOU.size == 0 &&
      state.eval.outcomes.customDiagnoses.length === 0
    ) {
      state.eval.status = "NORMAL"
      state.eval.final_Diagnoses.push(_NORMAL_FINDINGS)
      if (state.eval.savedDiagnoses && state.eval.savedDiagnoses.diagnosis) {
        const pattern = /<br\s?>/
        const isMultiple = pattern.test(state.eval.savedDiagnoses.diagnosis)
        let diagnosis = []
        if (isMultiple) {
          diagnosis = state.eval.savedDiagnoses.diagnosis.split(pattern)
        } else {
          diagnosis = [state.eval.savedDiagnoses.diagnosis]
        }
        diagnosis.forEach((e) => {
          if (e != null && !state.eval.final_Diagnoses.includes(e)) {
            state.eval.final_Diagnoses.push(e)
          }
        })
      }
    } else {
      state.eval.status = "ABNORMAL"

      if (combiDiagsOD.size > 0) {
        ///*** RIGHT EYE ***///
        combiDiagsOD.forEach((elOD) => {
          interim_DiagsOD.push(elOD)
        })
        let A1 = "" //'<ul><li>'
        let B1 = interim_DiagsOD.join(", \n")

        let D1 = A1.concat(B1)
        // let E1 = D1.indexOf("Bilateral") > -1 ? D1.replace(" on the Right.", "") : D1
        state.eval.final_Diagnoses.push(D1)
      }

      if (combiDiagsOS.size > 0) {
        ///*** LEFT EYE ***///
        combiDiagsOS.forEach((elOS) => {
          interim_DiagsOS.push(elOS)
        })
        let A2 = "" //'<ul><li>'
        let B2 = interim_DiagsOS.join(", \n")
        let D2 = A2.concat(B2)
        // let E2 = D2.indexOf("Bilateral") > -1 ? D2.replace(" on the Left.", "") : D2
        state.eval.final_Diagnoses.push(D2)
      }

      if (combiDiagsOU.size > 0) {
        ///*** BOTH EYES ***///
        combiDiagsOU.forEach((elOU) => {
          interim_DiagsOU.push(elOU)
        })
        let A3 = "" //'<ul><li>'
        let B3 = "Bilateral " //' on both eyes.</li></ul>'
        let C3 = interim_DiagsOU.join(", \n") + "\n"
        let D3 = A3.concat(B3, C3)
        state.eval.final_Diagnoses.push(D3)
      }
    }
    state.eval.outcomes.customDiagnoses.forEach((e) => {
      state.eval.final_Diagnoses.push(e)
    })

    const normalizeDiag = (d) => d.replace(/<br\s*\/?>/gi, '').trim()

    const seen = new Set()
    state.eval.final_Diagnoses = state.eval.final_Diagnoses.filter((diag) => {
      const norm = normalizeDiag(diag)
      if (seen.has(norm)) return false
      seen.add(norm)
      return true
    })

    let diags = state.eval.final_Diagnoses.map(d => d.trim()).filter(d => d.length > 0)

    state.eval.final_Diagnoses = diags.filter((diag, idx, arr) => {
      return !arr.some((otherDiag, otherIdx) => {
        return otherIdx !== idx && otherDiag.includes(diag)
      })
    })


    const seenDiagnoses = new Set();
    const normalizedDiagnoses = state.eval.final_Diagnoses.map(d =>
      typeof d === 'string' ? d.replace(/\n/g, '<br />') : d
    );

    const combinedString = normalizedDiagnoses.join('<br />');
    const allDiagnoses = combinedString.split('<br />');
    const nonEmptyDiagnoses = allDiagnoses
      .map(d => d.trim())
      .filter(d => d.length > 0 && d !== ',');
    const uniqueDiagnoses = [];
    nonEmptyDiagnoses.forEach(diag => {
      const cleanDiag = diag.replace(/^,\s*/, '').replace(/,\s*$/, '');

      if (!seenDiagnoses.has(cleanDiag)) {
        seenDiagnoses.add(cleanDiag);
        uniqueDiagnoses.push(cleanDiag);
      }
    });

    state.eval.final_Diagnoses = [];
    const odDiagnoses = uniqueDiagnoses.filter(d => d.includes('right eye') || d.includes('(OD)'));
    const osDiagnoses = uniqueDiagnoses.filter(d => d.includes('left eye') || d.includes('(OS)'));
    const ouDiagnoses = uniqueDiagnoses.filter(d => d.includes('Bilateral') || d.includes('(OU)'));

    if (odDiagnoses.length > 0) {
      state.eval.final_Diagnoses.push(odDiagnoses.join('<br />'));
    }
    if (osDiagnoses.length > 0) {
      state.eval.final_Diagnoses.push(osDiagnoses.join('<br />'));
    }
    if (ouDiagnoses.length > 0) {
      state.eval.final_Diagnoses.push(ouDiagnoses.join('<br />'));
    }

    const otherDiagnoses = uniqueDiagnoses.filter(d =>
      !odDiagnoses.includes(d) &&
      !osDiagnoses.includes(d) &&
      !ouDiagnoses.includes(d)
    );
    otherDiagnoses.forEach(d => state.eval.final_Diagnoses.push(d));
  },
  updateRecommendations() {
    // var _ROUTINE_FOLLOWUP = `
    //   <div style="line-height: 20px;">
    //     <b>Routine Follow-Up</b>: It is your responsibility to follow up as recommended in your </i>GlobeChek<i>
    //     report and in accordance withguidelines of the <i>American Academy of Ophthalmology</i> and
    //     <i>American Optometric Association</i> regarding eye care.
    //   </div>
    // `;

    var _ROUTINE_FOLLOWUP = `
         Routine Follow-Up: It is your responsibility to follow up as recommended in your GlobeChek
         report and in accordance with guidelines of the American Academy of Ophthalmology and
         American Optometric Association regarding eye care.
    `

    var _Diags = new Set(state.eval.final_Diagnoses)
    var _Recs = new Set()
    state.eval.final_Recommendations = []

    // VISION INFO
    state.eval.visionInfo.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.visionInfo.recommendOS.forEach((e) => {
      _Recs.add(e)
    })

    // EXTERNAL
    state.eval.externalPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.externalPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    //CORNEA
    state.eval.corneaPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.corneaPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    //PACYMETRY
    state.eval.pachymetryPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.pachymetryPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    //OPACITY
    state.eval.opacityPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.opacityPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    // FUNDUS
    state.eval.fundusPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.fundusPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    // OCT_MACULA
    state.eval.maculaPhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.maculaPhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })
    // OCT_NERVE
    state.eval.nervePhoto.recommendOD.forEach((e) => {
      _Recs.add(e)
    })
    state.eval.nervePhoto.recommendOS.forEach((e) => {
      _Recs.add(e)
    })

    state.eval.outcomes.customRecommendations.forEach((e) => {
      _Recs.add(e)
    })
    const isSaved = state.eval.savedDiagnoses && state.eval.savedDiagnoses.recommendation
    if (isSaved) {
      state.eval.final_Recommendations = []
      const isMultiple = state.eval.savedDiagnoses.recommendation.includes("<br >")
      let recommendation = []
      if (isMultiple) {
        recommendation = state.eval.savedDiagnoses.recommendation.split("<br >")
      } else {
        recommendation = [state.eval.savedDiagnoses.recommendation]
      }
      recommendation.forEach((e) => {
        if (e != null) {
          state.eval.final_Recommendations.push(e)
        }
      })
    }

    if (state.eval.status == "NORMAL" && !isSaved) {
      state.eval.final_Recommendations.push(_ROUTINE_FOLLOWUP)
    } else if (state.eval.status != "NORMAL" && !isSaved) {
      _Recs.forEach((element) => {
        if (element != "null") {
          state.eval.final_Recommendations.push(element)
        }
      })

      state.eval.final_Recommendations.push(_ROUTINE_FOLLOWUP)
    } else {
      _Recs.forEach((element) => {
        if (element != "null") {
          state.eval.final_Recommendations.push(element)
        }
      })
    }
  },

  clearReferrals() {
    state.eval.referrals = []
  },
  clearEval() {
    //Clear PATIENT INFO
    state.eval.patientInfo.internalID = ""
    state.eval.patientInfo.externalID = ""
    state.eval.patientInfo.firstName = ""
    state.eval.patientInfo.lastName = ""
    state.eval.patientInfo.fullName = ""
    state.eval.patientInfo.email = ""
    state.eval.patientInfo.phone = ""
    state.eval.patientInfo.dob = ""
    state.eval.patientInfo.gender = ""
    state.eval.patientInfo.wearsCorrectiveLens = ""
    state.eval.patientInfo.patientUserID = ""
    mutations.clearObject(state.eval.patientInfo.address)
    //console.log('PI:')
    //mutations.printObject(pi)

    //Clear ImagesArray
    mutations.clearObject(state.imagesArray)

    //Clear VISION INFO
    mutations.clearObject(state.eval.visionInfo)
    //console.log('VI:')
    //mutations.printObject(vi)

    //Clear MEDICAL INFO
    mutations.clearObject(state.eval.medicalInfo)

    //Clear Rx INFO
    mutations.clearObject(state.eval.rxInfo)

    //Clear SCREENING INFO
    mutations.clearObject(state.eval.screeningInfo)
    //console.log('SI:')
    //mutations.printObject(si)

    //Clear SCREENING NOTES
    mutations.clearObject(state.eval.notesInfo)

    //Clear SCREENING_ASSETS INFO
    mutations.clearObject(state.eval.screeningAssets)
    //console.log('SA:')
    //mutations.printObject(sa)

    //Clear PHOTO EXTERNAL
    state.eval.externalPhoto.imgExt = null
    mutations.clearSelected(state.eval.externalPhoto)

    //Clear PHOTO CORNEA
    state.eval.corneaPhoto.imgCorOD = ""
    state.eval.corneaPhoto.imgCorOS = ""
    mutations.clearSelected(state.eval.corneaPhoto)

    //Clear PHOTO PACHYMETRY
    state.eval.pachymetryPhoto.imgPacOD = ""
    state.eval.pachymetryPhoto.imgPacOS = ""
    mutations.clearSelected(state.eval.pachymetryPhoto)

    state.eval.opacityPhoto.imgOpaODOS = ""
    mutations.clearSelected(state.eval.opacityPhoto)

    state.eval.fundusPhoto.imgFunOD = ""
    state.eval.fundusPhoto.imgFunOS = ""
    mutations.clearSelected(state.eval.fundusPhoto)

    state.eval.maculaPhoto.imgMacOD = ""
    state.eval.maculaPhoto.imgMacOS = ""
    mutations.clearSelected(state.eval.maculaPhoto)

    state.eval.nervePhoto.imgNrvOD = ""
    state.eval.nervePhoto.imgNrvOS = ""
    mutations.clearSelected(state.eval.nervePhoto)

    //Clear SCREENING_ASSETS FDRs
    state.eval.final_Diagnoses = []
    state.eval.final_Recommendations = []
    state.eval.referrals = []

    //mutations.printObject(obj)

    // Clear DxOptions
    state.dxOptionsList = []
  },
  clearObject(o) {
    var obj = o
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key] = ""
      }
    }
  },
  clearSelected(o) {
    var obj = o
    obj.findingsOD = []
    obj.findingsOS = []
  },
  printObject(o) {
    var obj = o
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        console.log(key + " -> " + obj[key])
      }
    }
  },
  setImgReplace() {
    const image = String(Object.keys(state.imgReset)[0])
    const value = String(Object.values(state.imgReset)[0])
    switch (image) {
      case "EXT":
        state.eval.externalPhoto.imgExt = value
        break
      case "COROD":
        state.eval.corneaPhoto.imgCorOD = value
        break
      case "COROS":
        state.eval.corneaPhoto.imgCorOS = value
        break
      case "PACOD":
        state.eval.pachymetryPhoto.imgPacOD = value
        break
      case "PACOS":
        state.eval.pachymetryPhoto.imgPacOS = value
        break
      case "OPAODOS":
        state.eval.opacityPhoto.imgOpaODOS = value
        break
      case "FUNOD":
        state.eval.fundusPhoto.imgFunOD = value
        break
      case "FUNOS":
        state.eval.fundusPhoto.imgFunOS = value
        break
      case "MACOD":
        state.eval.maculaPhoto.imgMacOD = value
        break
      case "MACOS":
        state.eval.maculaPhoto.imgMacOS = value
        break
      case "NRVOD":
        state.eval.nervePhoto.imgNrvOD = value
        break
      case "NRVOS":
        state.eval.nervePhoto.imgNrvOS = value
        break
      default:
      // code block
    }
  },
  updateICD10State(_state, icd10List) {
    state.eval.icd10 = icd10List
  },
  updateCPTState(_state, cptList) {
    state.eval.cpt = cptList
  },
  RESET_EVAL_STATE(state) {
    state.eval.externalPhoto = {
      imgExt: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.corneaPhoto = {
      imgCorOD: "",
      imgCorOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.pachymetryPhoto = {
      imgPacOD: "",
      imgPacOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.opacityPhoto = {
      imgOpaODOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.fundusPhoto = {
      imgFunOD: "",
      imgFunOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.maculaPhoto = {
      imgMacOD: "",
      imgMacOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.eval.nervePhoto = {
      imgNrvOD: "",
      imgNrvOS: "",
      fIDs: [],
      findingsOD: [],
      findingsOS: [],
      diagnosesOD: [],
      diagnosesOS: [],
      diagnosesOU: [],
      recommendOD: [],
      recommendOS: []
    }

    state.selections = []
    state.mDxDiagnoses = []
    state.eval.final_Diagnoses = []
    state.eval.final_Recommendations = []

    state.eval.outcomes = {
      findings: [],
      diagnoses: [],
      customDiagnoses: [],
      recommendations: [],
      customRecommendations: [],
      diagnoseTxt: "",
      diagnoseHtml: "",
      recommendText: "",
      recommendHtml: ""
    }
  },
  UPDATE_DX_OPTIONS(state, payload) {
    state.dxOptionsList = payload
  },
  ADD_DX_OPTION(state, option) {
    const newItem = {
      REQ: `${option.id}.${option.eye_affected}`,
      RSLT: option
    }
    if (!state.dxOptionsList.find((item) => item.RSLT.id === newItem.RSLT.id)) {
      state.dxOptionsList.push(newItem)
    }
  },
  REMOVE_DX_OPTION(state, optionsToRemove) {
    const idsToRemove = optionsToRemove.map((opt) => opt.id)
    state.dxOptionsList = state.dxOptionsList.filter((opt) => !idsToRemove.includes(opt.RSLT.id))
  },
  UPDATE_DX_CARDS(state, { data, plain }) {
    if (plain) {
      const nonOtherCards = {};
      const otherCards = {};

      data.forEach((card) => {
        const modality = card.modality || 'Unknown';
        const eye = card.eye_affected || 'Unknown';

        if (!nonOtherCards[modality]) nonOtherCards[modality] = {};
        if (!nonOtherCards[modality][eye]) nonOtherCards[modality][eye] = [];

        if (!otherCards[modality]) otherCards[modality] = {};
        if (!otherCards[modality][eye]) otherCards[modality][eye] = [];

        if (card.isOtherFinding) {
          otherCards[modality][eye].push(card);
        } else {
          nonOtherCards[modality][eye].push(card);
        }
      });

      state.allDxCards = data;
      state.dxCards = nonOtherCards;
      state.otherDxCards = otherCards;
    } else {
      const nonOtherCards = {};
      const otherCards = {};

      Object.entries(data).forEach(([modality, eyesObj]) => {
        nonOtherCards[modality] = {};
        otherCards[modality] = {};

        Object.entries(eyesObj).forEach(([eye, cards]) => {
          nonOtherCards[modality][eye] = [];
          otherCards[modality][eye] = [];

          cards.forEach((card) => {
            if (card.isOtherFinding) {
              otherCards[modality][eye].push(card);
            } else {
              nonOtherCards[modality][eye].push(card);
            }
          });
        });
      });

      state.allDxCards = data;
      state.dxCards = nonOtherCards;
      state.otherDxCards = otherCards;
    }
  },

  UPDATE_CREATE_FINDING(state, payload) {
    state.createFinding = payload
  },
  UPDATE_FINAL_DIAGNOSES(state, payload) {
    state.eval.final_Diagnoses = payload
  },
  UPDATE_FINAL_RECOMMENDATIONS(state, payload) {
    state.eval.final_Recommendations = payload
  },
  UPDATE_SCREENING_STATUS(state, payload) {
    state.eval.screeningStatus = payload
  },
  UPDATE_SCREENING_DATE_EVAL(state, payload) {
    state.eval.screeningInfo.screeningDate = payload
  },
  UPDATE_SCREENING_DOB_EVAL(state, payload) {
    state.eval.patientInfo.dob = payload
  },
  SET_SCREENING_PATIENT_INFO(state, payload) {
    const merge = (target, source) => {
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
          if (
            typeof source[key] === "object" &&
            !Array.isArray(source[key]) &&
            source[key] !== null &&
            typeof target[key] === "object"
          ) {
            merge(target[key], source[key]) // deep merge
          } else {
            target[key] = source[key] // assign value
          }
        }
      }
    }

    merge(state.eval.patientInfo, payload)
  }
}

// Called externally to commit a State Mutation
const actions = {
  async loadScreening({ commit }, { screeningID, detailed = false }) {
    //console.log("***LOAD-SCREEN PAY: " + payload)
    state.screeningID = screeningID
    state.storageID = sessionStorage.getItem("storageID")

    var url = process.env.VUE_APP_URL + state.API_ROUTE + screeningID // sessionStorage.getItem("screeningID")
    const config = { headers: { "Content-Type": "application/json" }, params: { detailed: detailed } }
    await window.axios
      .get(url, config)
      .then((r) => r.data)
      .then((screening) => {
        commit("getScreening", screening)
      })
      .then(() => {
        commit("getPatientInfo")
        commit("getInsurerInfo")
        commit("getScreeningInfo")
        commit("getNotesInfo")
        commit("getScreeningAssets")
        commit("getVisionInfo")
        commit("getMedicalInfo")
        commit("getRxInfo")
        commit("getExternalPhoto")
        commit("getCorneaPhoto")
        commit("getPachymetryPhoto")
        commit("getOpacityPhoto")
        commit("getFundusPhoto")
        commit("getMaculaPhoto")
        commit("getNervePhoto")
        commit("getReferrals")
        commit("getGlassesHistory")
        commit("getContactsHistory")
        commit("getFindings")
        commit("getDiagnoses")
        commit("getScreeningStatus")
      })
      .catch(function (error) {
        state.STATUS = "An error occurred: " + error
        console.log(state.STATUS)
      })
  },
  async loadMedicalHistory({ commit }, payload) {
    console.log("** RUNNING UPDT MEDHIST **")
    var url = process.env.VUE_APP_URL + "/provenance/" + payload.FN + "/" + payload.LN + "/" + payload.EM

    const config = { headers: { "Content-Type": "application/json" } }
    const data = null

    await window.axios
      .post(url, data, config)
      .catch(function (error) {
        state.STATUS = "An error occurred: " + error
        console.log(state.STATUS)
      })
  },
  loadSummary({ commit }, payload) {
    commit("updateFCount", payload)
    commit("updateSummary", payload)
    commit("updateDiagnoses", payload)
    commit("updateRecommendations", payload)
  },
  clearEval({ commit }, payload) {
    commit("clearEval")
  },
  clearReferrals({ commit }, payload) {
    commit("clearReferrals")
  },
  SetImgReplace({ commit }, payload) {
    state.imgReset = payload
    commit("setImgReplace")
  },
  updateFindingMetrics({ commit }, payload) {
    state.selections = []

    state.selections.push(...state.eval.externalPhoto.fIDs)
    state.selections.push(...state.eval.corneaPhoto.fIDs)
    state.selections.push(...state.eval.pachymetryPhoto.fIDs)
    state.selections.push(...state.eval.opacityPhoto.fIDs)
    state.selections.push(...state.eval.fundusPhoto.fIDs)
    state.selections.push(...state.eval.maculaPhoto.fIDs)
    state.selections.push(...state.eval.nervePhoto.fIDs)

    if (state.selections.length === 0) {
      return
    }
    state.mDxDiagnoses = []

    //call UpdateUsage endpoint
    return new Promise((resolve, reject) => {
      const url = state.baseURL + "/dx-cards/update_usage"
      const data = {
        card_ids: state.selections.map((item) => item.split(".")[0])
      }
      window.axios.post(url, data).then((response) => {
        resolve(response.data)
      })
    })
  },
  async fetchDxCards({ commit }, {orgID, plain= false}) {
    try {
      const response = await window.axios.get(
        `${process.env.VUE_APP_URL}/dx-cards`,
        { params: { org_id: orgID, plain: plain } }
      );
      commit("UPDATE_DX_CARDS", { data: response.data, plain });
      return response.data;
    } catch (error) {
      console.error("Error setting dx cards:", error);
      throw error;
    }
  },
  async updateDxCardsUsage({ commit }, payload) {
    try {
      const response = await window.axios.post(`${process.env.VUE_APP_URL}/dx-cards/update_usage`, payload)
      return response.data
    } catch (error) {
      console.error("Error updating cards usage:", error)
      throw error
    }
  },
  addDxOption({ commit }, option) {
    commit("ADD_DX_OPTION", option)
  },
  removeDxOption({ commit }, option) {
    commit("REMOVE_DX_OPTION", option)
  },
  updateCreateFinding({ commit }, option) {
    commit("UPDATE_CREATE_FINDING", option)
  },
  updateFinalDiagnoses({ commit }, payload) {
    commit("UPDATE_FINAL_DIAGNOSES", payload)
  },
  updateFinalRecommendations({ commit }, payload) {
    commit("UPDATE_FINAL_RECOMMENDATIONS", payload)
  },
  updateScreeningStatus({ commit }, payload) {
    commit("UPDATE_SCREENING_STATUS", payload)
  },
  updateScreeningDateEval({ commit }, payload) {
    commit("UPDATE_SCREENING_DATE_EVAL", payload)
  },
  updateScreeningDobEval({ commit }, payload) {
    commit("UPDATE_SCREENING_DOB_EVAL", payload)
  },
  updateScreeningPatientInfo({ commit }, payload) {
    commit("SET_SCREENING_PATIENT_INFO", payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
